import { apiService } from "@/core/api";
import { API_ENDPOINTS } from "@/core/constants/endpoints";

interface FileUploadResponse {
  fid: Array<{ value: number }>;
  uuid: Array<{ value: string }>;
  uri: Array<{ value: string; url: string }>;
  filename: Array<{ value: string }>;
  filemime?: Array<{ value: string }>;
  filesize?: Array<{ value: number }>;
  status?: Array<{ value: boolean }>;
  created?: Array<{ value: string; format?: string }>;
  changed?: Array<{ value: string; format?: string }>;
}

export class DocumentUploadService {
  // Helper function to sanitize filename for HTTP headers
  private sanitizeFilename(filename: string): string {
    const lastDotIndex = filename.lastIndexOf(".");
    const extension =
      lastDotIndex !== -1 ? filename.substring(lastDotIndex) : "";
    const nameWithoutExt =
      lastDotIndex !== -1 ? filename.substring(0, lastDotIndex) : filename;

    // Replace non-ASCII characters with underscores and clean up
    const sanitizedName = nameWithoutExt
      .replace(/[^\x00-\x7F]/g, "_") // Replace non-ASCII with underscore
      .replace(/\s+/g, "_") // Replace spaces with underscore
      .replace(/[^a-zA-Z0-9_.-]/g, "_") // Replace special chars with underscore
      .replace(/_{2,}/g, "_") // Replace multiple underscores with single
      .replace(/^_+|_+$/g, ""); // Remove leading/trailing underscores

    // If name becomes empty, use a default
    const finalName = sanitizedName || "document";

    return finalName + extension;
  }

  async uploadFile(file: File): Promise<FileUploadResponse> {
    const entityTypeId = "node";
    const bundle = "partner";
    const fieldName = "field_documents";

    const url = `${API_ENDPOINTS.FILES.UPLOAD}/${entityTypeId}/${bundle}/${fieldName}?_format=json`;

    // Read file as ArrayBuffer for binary upload
    const fileBuffer = await file.arrayBuffer();

    // Sanitize filename to prevent non-ISO-8859-1 errors
    const sanitizedFilename = this.sanitizeFilename(file.name);

    // console.log("Uploading document file:", {
      // originalName: file.name,
      // sanitizedName: sanitizedFilename,
      // size: file.size,
      // type: file.type,
      // url: url,
    // });

    // Use apiService with binary data and required headers
    const response = await apiService.post<FileUploadResponse>(
      url,
      fileBuffer,
      {
        headers: {
          "Content-Type": "application/octet-stream",
          "Content-Disposition": `file; filename="${sanitizedFilename}"`,
          Accept: "application/json",
        },
      }
    );

    // console.log("Document upload response:", response);

    if (!response || !response.uri) {
      throw new Error("Invalid response from server - missing URI");
    }

    return response;
  }
}

export const documentUploadService = new DocumentUploadService();
